module.exports = __webpack_public_path__ + "img/Television-low.44650ec3.jpg";